import {WellConstructionStage, WellStatus} from '@features/wells/types';

export const getChipStylesByStageOrStatus = ({
    stage,
    isLightMode,
}: {
    stage: WellStatus | WellConstructionStage | string;
    isLightMode: boolean;
}) => {
    switch (stage) {
        case WellConstructionStage.Drilling:
            return {
                textColor: isLightMode ? 'rgba(46, 125, 50, 1)' : 'rgba(38, 166, 154, 1)',
                backgroundColor: isLightMode
                    ? 'rgba(46, 125, 50, 0.08)'
                    : 'rgba(38, 166, 154, 0.16)',
            };
        case WellConstructionStage.VMR:
            return {
                textColor: 'rgba(163, 106, 255, 1)',
                backgroundColor: 'rgba(110, 49, 210, 0.16)',
            };
        case WellConstructionStage.Development:
            return {
                textColor: isLightMode ? 'rgba(69, 130, 232, 1)' : 'rgba(73, 141, 255, 1)',
                backgroundColor: 'rgba(40, 112, 232, 0.16)',
            };
        case WellStatus.Conservation:
            return {
                textColor: isLightMode ? 'rgba(91, 91, 91, 1)' : 'rgba(170, 170, 171, 1)',
                backgroundColor: 'rgba(170, 170, 171, 0.16)',
            };
        case WellConstructionStage.StopWorksDueToWaitForDevelopment:
        case WellStatus.SuspendedDueToAdvancedDrilling:
            return {
                textColor: isLightMode ? 'rgba(210, 132, 17, 1)' : 'rgba(239, 165, 57, 1)',
                backgroundColor: isLightMode
                    ? 'rgba(239, 108, 0, 0.08)'
                    : 'rgba(255, 167, 38, 0.16)',
            };
        case WellConstructionStage.Moving:
            return {
                textColor: isLightMode ? 'rgba(234, 127, 93, 1)' : 'rgba(255, 138, 101, 1)',
                backgroundColor: 'rgba(255, 138, 101, 0.16)',
            };
        case WellStatus.Planned:
            return {
                textColor: isLightMode ? 'rgba(0, 184, 212, 1)' : 'rgba(0, 184, 212, 1)',
                backgroundColor: 'rgba(0, 184, 212, 0.16)',
            };
        case WellStatus.Inactive:
            return {
                textColor: isLightMode ? 'rgba(141, 141, 213, 1)' : 'rgba(169, 169, 230, 1)',
                backgroundColor: 'rgba(169, 169, 230, 0.16)',
            };
        case WellStatus.WaitForDevelopment:
            return {
                textColor: isLightMode ? 'rgba(237, 120, 0, 1)' : 'rgba(245, 124, 0, 1)',
                backgroundColor: isLightMode
                    ? 'rgba(237, 120, 0, 0.08)'
                    : 'rgba(245, 124, 0, 0.16)',
            };
        default:
            return {
                textColor: isLightMode ? 'rgba(46, 125, 50, 1)' : 'rgba(102, 187, 106, 1)',
                backgroundColor: isLightMode
                    ? 'rgba(46, 125, 50, 0.08)'
                    : 'rgba(102, 187, 106, 0.16)',
            };
    }
};
